import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import TableQuoteOrders from '../../../../../../specificComponents/QuoteOrders'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalCreateQuoteOrder from './ModalCreateQuoteOrder'

interface QuoteOrdersProps extends ComponentWithPermissions { }

const QuoteOrders: React.FC<QuoteOrdersProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('quoteOrders', 'Presupuestos'),
        newText: t('newQuoteOrder', 'Nuevo presupuesto'),
    }

    return (
        <BaseScreenTable TableComponent={TableQuoteOrders} CreateModalComponent={ModalCreateQuoteOrder} pageData={pageData} userPermissions={userPermissions} />
    )
}

export default QuoteOrders